import React, { useEffect } from "react";
import {
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Form,
  FormGroup,
  Input,
  InputGroup,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Table,
} from "reactstrap";
import { useState } from "react";
import FadeIn from "react-fade-in/lib/FadeIn";
import LoadingData from "../TESTPage/LoadingData";
import { useLocation, useNavigate } from "react-router-dom";
import SelectLeaveForm from "./SelectLeaveForm";
import ModalViewOrEditTableForm from "./ModalViewOrEditTableForm";
import axios from "axios";
import { GetCookieData, GetCookieToken } from "../Cookie/GetCookie";
import { ConvertDate } from "../Function/ConvertDate";
import ModalConfirmApprove from "./WaitApprove/ModalConfirmApprove";
import ModalCancelLeave from "./ModalCancelLeave";

import { Tooltip } from "@mui/material";
import { CheckBudgetYear } from "../Function/CheckBudgetYear";
import NewThaiDatePicker from "../../components/Common/NewThaiDatePicker";
import dayjs from "dayjs";
import { leaveStatusBadge } from "../Function/LeaveStatusBadge";
import { set } from "lodash";
import { CheckSubAdmin } from "../Function/CheckSubAdmin";
import ModalUser from "../SetData/SetCommander/ModalUser";
import { useInsertConText } from "../Context/InsertContext";

const TableForm = ({
  userInfo,
  isFromIndex,
  leaveData,
  leavePagination,
  setLeaveData,
  setLeavePagination,
  getLeaveData,
  RefreshLeaveDataTable,
  SelectBudgetYear
}) => {
  const baseURL = process.env.REACT_APP_API_CORS;
  const token = GetCookieToken("userToken");
  const user = GetCookieData("userData");
  const user_id = user?.user_id;
  const location = useLocation();
  const paramValue =
    new URLSearchParams(location?.search).get("exitbefore") || "";

  const [modalLeaveData, setModalLeaveData] = useState(false);
  const [leaveDataEdit, setLeaveDataEdit] = useState();
  const [startCancel, setStartCancel] = useState();
  const [endCancel, setEndCancel] = useState();
  const [allDayCancel, setAllDayCancel] = useState([]);
  const [selectDayCancel, setSelectDayCancel] = useState([]);
  const [holiday, setHoliday] = useState([]);
  const [isloading, setIsLoading] = useState(true);
  const [budgetYearSelectList, setBudgetYearSelectList] = useState([]);
  const [searchData, setSearchData] = useState({
    currentPage: 1,
    totalPage: 1,
    leave_type_id: "",
    fromDate: "",
    toDate: "",
    status: "",
    budget_year: "",
    user_id: "",
    user_name: "",
  });
  const [sortCount, setSortCount] = useState({
    id: 0,
    typeId: 0,
    fromDate: 0,
    toDate: 0,
  });
  const [modalState, setModalState] = useState();
  const [cancelLeave, setCancelLeave] = useState({
    modal: false,
    status: "",
  });
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [typeLeaveName, setTypeLeaveName] = useState([]);
  const [configForm, setConfigForm] = useState([]);
  const [getUserApprove, setGetUserApprove] = useState([]);
  const [getFlowApprove, setGetFlowApprove] = useState([]);

  const { insert, setInsert, clearValue } = useInsertConText();

  useEffect(() => {
    setIsLoading(true);
    clearValue()
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  }, [leaveData]);

  const getFirstBudgetYearForSearch = async () => {
    try {
      const url = baseURL + `/api/leave/datatable`;
      const params = new URLSearchParams({
        page: 1,
        size: 1,
        "order[0]": "budget_year",
        "order[1]": "ASC",
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const res = await axios.get(url, config);
      if (res?.data?.result[0]?.budget_year) {
        let firstYear = Number(res?.data?.result[0]?.budget_year);
        let lastYear = Number(CheckBudgetYear());
        let arrYear = [];
        for (let i = firstYear; i <= lastYear; i++) {
          arrYear.push(i);
        }
        arrYear?.sort((a, b) => b - a);
        return setBudgetYearSelectList(arrYear);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
    getFirstBudgetYearForSearch();
  }, []);

  useEffect(() => {
    if (allDayCancel?.length > 0 || selectDayCancel?.length > 0) {
      selectDayCancel?.sort(
        (a, b) => new Date(a?.date_cancel) - new Date(b?.date_cancel)
      );
      allDayCancel?.sort(
        (a, b) => new Date(a?.date_cancel) - new Date(b?.date_cancel)
      );
    }
  }, [allDayCancel, selectDayCancel]);

  useEffect(() => {
    if (leaveDataEdit) {
      getConfigAll();
      getHoliday(new Date()?.getFullYear());
    }
    getConfigAll();
  }, [leaveDataEdit]);

    useEffect(() => {
      if (insert.task === "select_user_filter") {
        setSearchData((prev) => ({
          ...prev,
          user_name: insert.insert_name,
          user_id: insert.insert_id,
        }))
      }
    }, [insert])

  const getSearchLeaveData = async (indexPage = 1) => {
    setIsLoading(true)
    
    try {
      const url = baseURL + `/api/leave/datatable`;
      const params = new URLSearchParams({
        page: indexPage,
        size: isFromIndex ? 5 : 10,
        "order[0]": "created_date",
        "order[1]": "DESC",
        "filter[user_id][0]": searchData?.user_id || user_id,
        "filter[budget_year][0]": SelectBudgetYear || (searchData?.budget_year === "" ? CheckBudgetYear() : searchData?.budget_year),
      });
      searchData?.leave_type_id && params.append("filter[leave_type_id][0]", searchData?.leave_type_id)
      searchData?.fromDate && params.append("filter[leave_dmy_start][0]", ConvertDate(searchData?.fromDate)?.toDateISO())
      searchData?.toDate && params.append("filter[leave_dmy_end][0]", ConvertDate(searchData?.toDate)?.toDateISO())
      if (searchData?.status && searchData?.status === "5") {
        params.append("filter[leave_status][0]", '0');
        params.append("filter[leave_status][1]", '5');
      } else if (searchData?.status && searchData?.status !== "5"){
        params.append("filter[leave_status][0]", searchData?.status);
      }
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const res = await axios.get(url, config);
      setLeaveData(res?.data?.result);
      setSearchData((prev) => ({
        ...prev,
        currentPage : res?.data?.info?.currentPage,
        // currentPage : indexPage,
        totalPage: res?.data?.info?.totalPage,
      }))
      setLeavePagination((prev) => ({
        ...prev,
        currentPage: res?.data?.info?.currentPage,
        totalPage: res?.data?.info?.totalPage,
        totalRows: res?.data?.info?.totalRows,
      }));
    } catch (err) {
      console.error(err);
    }
    setIsLoading(false)
  };

  useEffect(() => {
    setSearchData((prev) => ({
      ...prev,
      currentPage : leavePagination?.currentPage,
      // currentPage : indexPage,
      totalPage: leavePagination?.totalPage,
    }))
  }, [leavePagination])
  

  ///////////////// เรียกใช้งานหาใบลาโดยใช้ ID(เลขที่ใบลา)
  const GetLeaveDataEdit = async (id) => {
    try {
      const res = await axios.get(baseURL + `/api/leave/data/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setLeaveDataEdit((prev) => ({
        ...prev,
        user_name: userInfo?.user_name,
        user_position_name: userInfo?.user_position_name,
        cont_to_name_1: userInfo?.cont_to_name_1,
        ...res?.data?.result,
      }));
      await SetStartEndCancel(
        res?.data?.result?.leave_from_date,
        res?.data?.result?.leave_to_date
      );
      let allCancel = await getAllDayCancel(
        new Date(res?.data?.result?.leave_from_date),
        new Date(res?.data?.result?.leave_to_date)
      );
      await getDataCancelDayById(id, allCancel);
    } catch (err) {
      console.error(err);
    }
  };

  //////////// ดึงข้อมูลวันหยุดราชการจาก database
  const getHoliday = async (year) => {
    try {
      const res = await axios.get(baseURL + `/api/masterdata/holiday/${year}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setHoliday(res?.data?.result);
    } catch (err) {
      console.error(err);
    }
  };

  /////////// คำนวณวันหยุดจาก leave_from_date และ leave_to_date ใส่ใน select
  const getAllDayCancel = async (
    startCancel = new Date(),
    endCancel = new Date()
  ) => {
    const isWeekend = (date) => {
      const day = new Date(date)?.getDay();
      return day === 6 || day === 0; // 6 คือวันเสาร์, 0 คือวันอาทิตย์
    };

    const isThaiPublic = (date) => {
      const localDate = new Date(date);
      localDate.setHours(0, 0, 0, 0);
      return holiday.some((item) => {
        const startDate = new Date(item?.date_start_holiday)?.setHours(
          0,
          0,
          0,
          0
        );
        const endDate = new Date(item?.date_end_holiday)?.setHours(0, 0, 0, 0);
        return localDate >= startDate && localDate <= endDate;
      });
    };

    setAllDayCancel([]);
    let ref = [];

    for (
      let i = new Date(new Date(startCancel).setHours(0, 0, 0, 0));
      i <= new Date(new Date(endCancel).setHours(0, 0, 0, 0));
      i.setDate(i.getDate() + 1)
    ) {
      let currentDate = new Date(i);
      let newOBJ = {
        date_cancel: currentDate,
      };
      if (!isWeekend(i) && !isThaiPublic(i)) {
        ref.push(newOBJ);

        setAllDayCancel((prev) => [...prev, newOBJ]);
      }
    }
    return ref;
  };

  ////////////// กำหนดวันเริ่มต้นและสิ้นสุดเพื่อหาช่วงวันที่
  const SetStartEndCancel = async (leaveFromDate, leavetoDate) => {
    setStartCancel(leaveFromDate);
    setEndCancel(leavetoDate);
  };

  //////////// เปิดปิด Modalของข้อมูล leave_data
  const ToggleModalLeaveData = () => {
    if (modalLeaveData === false) {
      setModalLeaveData(true);
    } else {
      setModalLeaveData(false);
      setLeaveDataEdit("");
      setGetUserApprove([]);
      setGetFlowApprove([]);
    }
  };

  ////////// ส่งไฟล์ไปที่ฐานข้อมูลโดยกำหนดเลขที่ใบลา
  const handleSentFile = (id) => {
    const formData = new FormData();
    formData.append("file", leaveDataEdit?.file_data);
    axios
      .post(baseURL + `/api/leave/file/${id}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
      })
      .catch((err) => {
        console.error(err);
      });
  };

  //////////////// แก้ไขข้อมูลใบลา
  const handleEditLeaveDataEdit = async (id) => {
    try {
      const res = await axios.put(
        baseURL + `/api/leave/${id}`,
        {
          leave_type_id: leaveDataEdit?.leave_type_id, //ประเภทใบลา
          form_type: leaveDataEdit?.form_type, //ประเภทฟอร์มการลา
          form_name: leaveDataEdit?.form_name, //ชื่อฟอร์มการลา
          budget_year: leaveDataEdit?.budget_year, //ปีงบประมาณ
          leave_name: leaveDataEdit?.leave_name, //ชื่อเรื่องการลา
          send_to: leaveDataEdit?.send_to, //เรียน
          leave_reason:
            configForm?.form_type === 1 || configForm?.form_type === 11
              ? leaveDataEdit?.leave_reason
              : undefined, //เนื่องจาก
          leave_from_date: ConvertDate(
            leaveDataEdit?.leave_from_date
          )?.toDateISO(), //ตั้งแต่วันที่
          leave_from_timetype: leaveDataEdit?.leave_from_timetype, //ช่วงเวลา
          leave_to_date: ConvertDate(leaveDataEdit?.leave_to_date)?.toDateISO(), //ถึงวันที่
          leave_to_timetype: leaveDataEdit?.leave_to_timetype, //ช่วงเวลา
          //leave_years: data?.leave_years, //ไม่ต้องส่งไป เพราะไม่ได้ใช้
          //leave_months: data?.leave_months, //ไม่ต้องส่งไป เพราะไม่ได้ใช้
          leave_days: leaveDataEdit?.leave_days, //กำหนดหรือจำนวนวัน
          contact_address:
            configForm?.form_type === 1 || configForm?.form_type === 2
              ? leaveDataEdit?.contact_address
              : undefined, //สถานที่ติดต่อ
          abroad_for:
            configForm?.form_type === 3 || configForm?.form_type === 7 ? leaveDataEdit?.abroad_for : undefined, //เพื่อไป
          abroad_country:
            configForm?.form_type === 3 || configForm?.form_type === 7
              ? leaveDataEdit?.abroad_country
              : undefined, //ณ ประเทศ
          abroad_ref:
            (configForm?.form_type === 3 && leaveDataEdit?.abroad_ref) ? `${leaveDataEdit?.abroad_ref}` : undefined, //ไอดีลากิจหรือลาพักผ่อน
          abroad_ref_2:
            (configForm?.form_type === 3 && leaveDataEdit?.abroad_ref_2) ? `${leaveDataEdit?.abroad_ref_2}` : undefined, //ไอดีลากิจหรือลาพักผ่อน
          ordinate_ever:
            configForm?.form_type === 4
              ? leaveDataEdit?.ordinate_ever
              : undefined, //เคยอุปสมบทไหม
          ordinate_temple:
            configForm?.form_type === 4
              ? leaveDataEdit?.ordinate_temple
              : undefined, //จะอุปสมบท ณ วัด
          ordinate_temple_place:
            configForm?.form_type === 4
              ? leaveDataEdit?.ordinate_temple_place
              : undefined, //ตั้งอยู่ ณ
          ordinate_date:
            configForm?.form_type === 4
              ? ConvertDate(leaveDataEdit?.ordinate_date)?.toDateISO()
              : undefined, //วันที่อุปสมบท
          ordinate_live_temple:
            configForm?.form_type === 4
              ? leaveDataEdit?.ordinate_live_temple
              : undefined, //จำพรรษา ณ วัด
          ordinate_live_place:
            configForm?.form_type === 4
              ? leaveDataEdit?.ordinate_live_place
              : undefined, //ตั้งอยู่ ณ
          conscription_from:
            configForm?.form_type === 6
              ? leaveDataEdit?.conscription_from
              : undefined,
          conscription_place:
            configForm?.form_type === 6
              ? leaveDataEdit?.conscription_place
              : undefined,
          conscription_date:
            configForm?.form_type === 6
              ? ConvertDate(leaveDataEdit?.conscription_date)?.toDateISO()
              : undefined,
          conscription_for:
            configForm?.form_type === 6
              ? leaveDataEdit?.conscription_for
              : undefined,
          conscription_to_place:
            configForm?.form_type === 6
              ? leaveDataEdit?.conscription_to_place
              : undefined,
          training_fund_from:
            configForm?.form_type === 7
              ? leaveDataEdit?.training_fund_from ?? undefined
              : undefined,
          spouse_name:
            configForm?.form_type === 8
              ? leaveDataEdit?.spouse_name
              : undefined,
          spouse_position:
            configForm?.form_type === 8
              ? leaveDataEdit?.spouse_position
              : undefined,
          spouse_department:
            configForm?.form_type === 8
              ? leaveDataEdit?.spouse_department
              : undefined,
          spouse_country:
            configForm?.form_type === 8
              ? leaveDataEdit?.spouse_country
              : undefined,
          spouse_from_date:
            configForm?.form_type === 8
              ? ConvertDate(leaveDataEdit?.spouse_from_date)?.toDateISO()
              : undefined,
          spouse_to_date:
            configForm?.form_type === 8
              ? ConvertDate(leaveDataEdit?.spouse_to_date)?.toDateISO()
              : undefined,
          outside_place:
            configForm?.form_type === 9
              ? leaveDataEdit?.outside_place
              : undefined,
          practice_reason:
            configForm?.form_type === 10
              ? leaveDataEdit?.practice_reason
              : undefined,

          note: leaveDataEdit?.note || "", //หมายเหตุ
          user_id: leaveDataEdit?.user_id, //ไอดีผู้ส่งฟอร์ม
          leave_status: "4", //leaveDataEdit?.leave_status, //สถานะใบลา
          approve_status: leaveDataEdit?.leave_status === "4" ? "0" : "2", //สถานะการอนุมัติ
          approve_user_id: leaveDataEdit?.approve_user_id,
          approve_user: leaveDataEdit?.approve_user,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      handleSentFile(res?.data?.id);
      ToggleModalLeaveData();
      RefreshLeaveDataTable(isFromIndex);
    } catch (err) {
      console.error(err);
    }
  };

  ///////////////// เปิดปิด Modal ของการยกเลิกใบลาและส่ง status ของการยกเลิก
  const toggleCancelLeave = (status) => {
    if (cancelLeave?.modal === false) {
      setCancelLeave((prev) => ({
        ...prev,
        modal: true,
        status: status,
      }));
    }
    if (cancelLeave?.modal === true) {
      setCancelLeave((prev) => ({
        ...prev,
        modal: false,
        status: "",
      }));
    }
  };

  ///////////////////////// ยกเลิกใบลา (ไม่ใช่การลบแต่เปลี่ยนสถานะเป็นยกเลิก)
  const handleCancelLeave = async (id, status) => {
    try {
      const res = await axios.put(
        baseURL + `/api/leave/${id}`,
        {
          leave_type_id: leaveDataEdit?.leave_type_id, //ประเภทใบลา
          form_type: leaveDataEdit?.form_type, //ประเภทฟอร์มการลา
          form_name: leaveDataEdit?.form_name, //ชื่อฟอร์มการลา
          budget_year: leaveDataEdit?.budget_year, //ปีงบประมาณ
          leave_name:
            status === "7"
              ? leaveDataEdit?.leave_name + " (ขอยกเลิกใบลา)"
              : leaveDataEdit?.leave_name, //ชื่อเรื่องการลา
          send_to: leaveDataEdit?.send_to, //เรียน
          leave_from_date: ConvertDate(
            leaveDataEdit?.leave_from_date
          )?.toDateISO(), //ตั้งแต่วันที่
          leave_from_timetype: leaveDataEdit?.leave_from_timetype, //ช่วงเวลา
          leave_to_date: ConvertDate(leaveDataEdit?.leave_to_date)?.toDateISO(), //ถึงวันที่
          leave_to_timetype: leaveDataEdit?.leave_to_timetype, //ช่วงเวลา
          leave_days: leaveDataEdit?.leave_days,
          change_days: leaveDataEdit?.change_days,

          leave_reason:
            leaveDataEdit?.form_type === 1 || leaveDataEdit?.form_type === 11
              ? leaveDataEdit?.leave_reason
              : "", //เนื่องจาก

          contact_address:
            leaveDataEdit?.form_type === 1 || leaveDataEdit?.form_type === 2
              ? leaveDataEdit?.contact_address
              : undefined, //สถานที่ติดต่อ
          abroad_for:
            leaveDataEdit?.form_type === 3
              ? leaveDataEdit?.abroad_for
              : undefined, //เพื่อไป
          abroad_country:
            leaveDataEdit?.form_type === 3 || leaveDataEdit?.form_type === 7
              ? leaveDataEdit?.abroad_country
              : undefined, //ณ ประเทศ
          abroad_ref:
            leaveDataEdit?.form_type === 3
              ? `${leaveDataEdit?.abroad_ref ?? ''}`
              : undefined, //ไอดีลากิจหรือลาพักผ่อน
          abroad_ref_2:
            leaveDataEdit?.form_type === 3
              ? `${leaveDataEdit?.abroad_ref_2 ?? ''}`
              : undefined, //ไอดีลากิจหรือลาพักผ่อน
          ordinate_ever:
            leaveDataEdit?.form_type === 4
              ? leaveDataEdit?.ordinate_ever
              : undefined, //เคยอุปสมบทไหม
          ordinate_temple:
            leaveDataEdit?.form_type === 4
              ? leaveDataEdit?.ordinate_temple
              : undefined, //จะอุปสมบท ณ วัด
          ordinate_temple_place:
            leaveDataEdit?.form_type === 4
              ? leaveDataEdit?.ordinate_temple_place
              : undefined, //ตั้งอยู่ ณ
          ordinate_date:
            leaveDataEdit?.form_type === 4
              ? ConvertDate(leaveDataEdit?.ordinate_date)?.toDateISO()
              : undefined, //วันที่อุปสมบท
          ordinate_live_temple:
            leaveDataEdit?.form_type === 4
              ? leaveDataEdit?.ordinate_live_temple
              : undefined, //จำพรรษา ณ วัด
          ordinate_live_place:
            leaveDataEdit?.form_type === 4
              ? leaveDataEdit?.ordinate_live_place
              : undefined, //ตั้งอยู่ ณ
          conscription_from:
            leaveDataEdit?.form_type === 6
              ? leaveDataEdit?.conscription_from
              : undefined,
          conscription_place:
            leaveDataEdit?.form_type === 6
              ? leaveDataEdit?.conscription_place
              : undefined,
          conscription_date:
            leaveDataEdit?.form_type === 6
              ? ConvertDate(leaveDataEdit?.conscription_date)?.toDateISO()
              : undefined,
          conscription_for:
            leaveDataEdit?.form_type === 6
              ? leaveDataEdit?.conscription_for
              : undefined,
          conscription_to_place:
            leaveDataEdit?.form_type === 6
              ? leaveDataEdit?.conscription_to_place
              : undefined,
          training_fund_from:
            leaveDataEdit?.form_type === 7
              ? `${leaveDataEdit?.training_fund_from ?? ''}`
              : undefined,
          spouse_name:
            leaveDataEdit?.form_type === 8
              ? leaveDataEdit?.spouse_name
              : undefined,
          spouse_position:
            leaveDataEdit?.form_type === 8
              ? leaveDataEdit?.spouse_position
              : undefined,
          spouse_department:
            leaveDataEdit?.form_type === 8
              ? leaveDataEdit?.spouse_department
              : undefined,
          spouse_country:
            leaveDataEdit?.form_type === 8
              ? leaveDataEdit?.spouse_country
              : undefined,
          spouse_from_date:
            leaveDataEdit?.form_type === 8
              ? ConvertDate(leaveDataEdit?.spouse_from_date)?.toDateISO()
              : undefined,
          spouse_to_date:
            leaveDataEdit?.form_type === 8
              ? ConvertDate(leaveDataEdit?.spouse_to_date)?.toDateISO()
              : undefined,
          outside_place:
            leaveDataEdit?.form_type === 9
              ? leaveDataEdit?.outside_place
              : undefined,
          practice_reason:
            leaveDataEdit?.form_type === 10
              ? leaveDataEdit?.practice_reason
              : undefined,

          note: !leaveDataEdit?.note ? "" : undefined, //หมายเหตุ
          user_id: leaveDataEdit?.user_id, //ไอดีผู้ส่งฟอร์ม
          leave_status: status, //สถานะใบลา
          approve_status: `${leaveDataEdit?.approve_status ?? 0}`, //สถานะการอนุมัติ
          approve_user_id: leaveDataEdit?.approve_user_id,
          approve_user: leaveDataEdit?.approve_user,

          cancel_reason: leaveDataEdit?.cancel_reason,
          cancel_status: leaveDataEdit?.cancel_status,
          change_days: `${leaveDataEdit?.change_days ?? leaveDataEdit?.leave_days}`,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toggleCancelLeave();
      getLeaveData(leavePagination?.currentPage, false);
    } catch (err) {
      console.error(err);
    }
  };

  //////////////// รับ Config ของทุก Form การลา
  const getConfigAll = async () => {
    try {
      const res = await axios.get(baseURL + "/api/leave/config/all", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setConfigForm(res?.data?.form_leave[leaveDataEdit?.form_type - 1]);
      setTypeLeaveName(res?.data?.form_leave);
    } catch (err) {
      console.error(err);
    }
  };

  let reportURL = "";

  const [loadingPdf, setLoadingPdf] = useState(false)
  /////////////////// ดู PDF ของใบลาแจ่ละประเภท
  const handleGetReport = async (reportType, leaveDataId) => {
    try {
      setLoadingPdf(true)
      const res = await axios.get(
        baseURL +
          `/api/report/leave/pdf/${reportType}/${leaveDataId}?mode=path`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      reportURL = res?.data?.path;
      setLoadingPdf(false)
    } catch (err) {
      window.alert("ไม่สามารถดูไฟล์ PDF ได้");
      console.error(err);
    }
  };

  //////////////////// ดู Flow การ approve ของใบลา
  const getFlowApproveUserbyId = async (id) => {
    try {
      const url = baseURL + "/api/leave/approve/datatable";
      const params = new URLSearchParams({
        page: 1,
        size: 10,
        "order[0]": "created_date",
        "order[1]": "ASC",
        "filter[leave_data_id][0]": id,
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const res = await axios.get(url, config);
      setGetUserApprove(res?.data?.result);
      setGetFlowApprove(res?.data?.position_users_approve);
    } catch (err) {
      console.error(err);
    }
  };

  //////////// เปิดปิด Modal หลังดำเนินการเสร็จสิ้น
  const handleOpenSubmitSuccess = () => {
    setSubmitSuccess(true);

    setTimeout(() => {
      setSubmitSuccess(false);
    }, 1900);
  };
  const handleCloseSubmitSuccess = () => {
    setSubmitSuccess(false);
  };

  //////////////// จัดเรียงตาราง leave_data
  const handleSortDataTable = (count, field, order) => {
    if (count === 0) {
      // getLeaveDataTable();
      setSortCount((prev) => ({ ...prev, [field]: prev[field] + 1 }));
    } else if (count === 1) {
      // getLeaveDataTable();
      setSortCount((prev) => ({ ...prev, [field]: prev[field] + 1 }));
    } else {
      // getLeaveDataTable();
      setSortCount((prev) => ({
        ...prev,
        id: 0,
        typeId: 0,
        fromDate: 0,
        toDate: 0,
      }));
    }
  };

  //////////////////// แก้ไขข้อมูลของตาราง approve ในกรณีที่ต้องการแก้ไขใบลา และอัพเดตค่าใน field ของตาราง approve
  const handleEditDataInApproveTable = async () => {
    try {
      const res = await axios.post(
        baseURL + `/api/leave/fixLeaveApprove`,
        {
          leave_data_id: leaveDataEdit?.leave_data_id,
          leave_from_date: ConvertDate(
            leaveDataEdit?.leave_from_date
          ).toDateISO(),
          leave_from_timetype: leaveDataEdit?.leave_from_timetype,
          leave_to_date: ConvertDate(leaveDataEdit?.leave_to_date).toDateISO(),
          leave_to_timetype: leaveDataEdit?.leave_to_timetype,
          leave_days: leaveDataEdit?.leave_days,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (err) {
      console.error(err);
    }
  };

  ////////// ค้นหาวันที่ถูกยกเลิกของใบลา โดยอ้างอิงจาก id ของใบลา
  const getDataCancelDayById = async (id = "", allCancel = [],) => {
    try {
      const url = baseURL + "/api/leave/cancel/list/datatable";
      const params = new URLSearchParams({
        page: 1,
        size: 10000,
        "order[0]": "date_cancel",
        "order[1]": "ASC",
        "filter[leave_data_id][0]": id,
        "filter[cancel_date_status][0]": 1,
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const res = await axios.get(url, config);
      
      setSelectDayCancel(res?.data?.result);
      res?.data?.result &&
        res?.data?.result?.map((item) => {
          if (
            allCancel?.find(
              (a) =>
                new Date(a?.date_cancel)?.toLocaleDateString() ===
                new Date(item?.date_cancel)?.toLocaleDateString()
            )
          ) {
            setAllDayCancel((prev) =>
              prev.filter(
                (a) =>
                  new Date(a?.date_cancel)?.toLocaleDateString() !==
                  new Date(item?.date_cancel)?.toLocaleDateString()
              )
            );
          }
        });
    } catch (err) {
      console.error(err);
    }
  };
  const getDataCancelDayToEdit = async (id) => {
    try {
      const url = baseURL + "/api/leave/cancel/list/datatable";
      const params = new URLSearchParams({
        page: 1,
        size: 300,
        "order[0]": "date_cancel",
        "order[1]": "ASC",
        "filter[leave_data_id][0]": id,
        "filter[cancel_date_status][0]": 2,
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const res = await axios.get(url, config);
      return res?.data?.result.length !== 0 ? true : false
    } catch (err) {
      console.error(err);
      return false
    }
  };

  useEffect(() => {
    searchData.fromDate > searchData.toDate && setSearchData((prev) => ({
      ...prev,
      fromDate: searchData.toDate,
    }));
  }, [searchData.fromDate,searchData.toDate])

  const [modalCancel, setModalCancel] = useState({
    modal: false,
    status: "",
  });

  const toggleDownloadFileModal = (status) => {
    if (modalCancel?.modal === false) {
      setModalCancel((prev) => ({
        ...prev,
        modal: true,
        status: status,
      }));
    } else {
      setModalCancel((prev) => ({
        ...prev,
        modal: false,
        status: "",
      }));
    }
  };

  const [leaveTypeIdSelectFile, setLeaveTypeIdSelectFile] = useState(null)
  const [leaveDataIdSelectFile, setLeaveDataIdSelectFile] = useState(null)
  const [formNameFile, setformNameFile] = useState(null)
  
  const [loadingDoc, setLoadingDoc] = useState(false)
  const downloadDocx = async (reportType,leaveDataId, leaveName) => {
      try {
        setLoadingDoc(true)
        const response = await axios.get(
          `${baseURL}/api/report/leave/docx/${reportType}/${leaveDataId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            responseType: 'blob',
          }
        );
        // สร้าง URL จาก blob
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const a = document.createElement('a');
        a.href = url;
        a.download = `แบบใบ${leaveName}.docx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);

        setLoadingDoc(false)
      } catch (error) {
        window.alert("ไม่สามารถดาวน์โหลดไฟล์ได้")
        console.error('Error:', error);
      }
  };

  const setFromDateSearch = (e) => {
    setSearchData((prev) => ({
      ...prev,
      fromDate: e,
      toDate: e,
    }));
  }

  const setToDateSearch = (e) => {
    setSearchData((prev) => ({
      ...prev,
      toDate: e,
    }));
  }

  const options = [
    { value: '', label: 'ทั้งหมด' },
    { value: '4', label: 'รออนุญาต' },
    { value: '2', label: 'รออนุมัติ' },
    { value: '3', label: 'อนุญาต' },
    { value: '5', label: 'อนุมัติ' },
    { value: '9', label: 'ส่งกลับเพื่อแก้ไข' },
    { value: '7', label: 'ขออนุญาตยกเลิก' },
    { value: 'B', label: 'อนุญาตยกเลิก' },
    { value: 'A', label: 'อนุมัติยกเลิก' },
    { value: 'C', label: 'อนุมัติยกเลิกบางวัน' }
  ];

  dayjs.locale("th")

  return (
    <React.Fragment>
      <Card style={{ minHeight: isFromIndex ? "450px" : "82vh" }}>
        <CardBody className="pb-0">
          {!isFromIndex && (
            <>
              <Row className="mb-4">
                <Col xxl={8} xs={7}>
                  <h4>ประวัติการลา</h4>
                </Col>
                <Col xxl={4} xs={12} className="d-flex justify-content-end">
                  <SelectLeaveForm
                    paramValue={paramValue}
                    // getLeaveDataTable={getLeaveDataTable}
                    getLeaveData={getLeaveData}
                    RefreshLeaveDataTable={RefreshLeaveDataTable}
                    userInfo={userInfo}
                    isFromIndex={false}
                  />
                </Col>
              </Row>
              <Row className="mb-4">
                <Col>
                  <Form>
                    <Row className="d-flex justify-content-end">
                      <Col className="">
                        <Row className="d-flex justify-content-end">
                          <Col xxl={3} xl={3} xs={12}>
                            <Row>
                              <Label
                                className="text-end pe-0"
                                xl={2}
                                sm={2}
                                xs={2}
                              >
                                เรื่อง
                              </Label>
                              <Col>
                                <Input
                                  type="select"
                                  placeholder="กรุณาระบุ"
                                  value={searchData?.leave_type_id}
                                  onChange={async (e) => {
                                    setSearchData((prev) => ({
                                      ...prev,
                                      leave_type_id: e.target.value,
                                    }));
                                  }}
                                >
                                  <option value="">ทั้งหมด</option>
                                  {typeLeaveName?.map((item, idx, arr) => {
                                    return (
                                      <React.Fragment key={idx}>
                                        {item?.leave_type?.map((item2) => {
                                          if (idx !== arr.length - 1) {
                                            return (
                                              <option
                                                key={item2?.leave_type_id}
                                                value={item2?.leave_type_id}
                                              >
                                                {item2?.leave_name}
                                              </option>
                                            );
                                          }
                                        })}
                                      </React.Fragment>
                                    );
                                  })}
                                </Input>
                              </Col>
                            </Row>
                          </Col>
                          <Col xxl={2} xl={3} sm={6}>
                            <Row>
                              <Label
                                className="text-end pe-0"
                                xxl={4}
                                xl={3}
                                sm={3}
                                xs={2}
                              >
                                ตั้งแต่
                              </Label>
                              <Col>
                                {/* <Flatpickr
                                  className="form-control d-block"
                                  placeholder="วัน/เดือน/ปี"
                                  options={{
                                    dateFormat: "d-m-Y",
                                    ariaDateFormat: "F j, Y",
                                    locale: "th",
                                  }}
                                  value={searchData?.fromDate}
                                  onChange={(e) => {
                                    setSearchData((prev) => ({
                                      ...prev,
                                      fromDate: e[0],
                                    }));
                                    if (searchData?.toDate !== 0) return 0;
                                    // return getLeaveDataTable(
                                    // 1,
                                    // selectRow,
                                    // "created_date",
                                    // "DESC",
                                    // searchData?.title,
                                    // ConvertDate(e[0])?.toOnlyDate(),
                                    // ConvertDate(searchData?.toDate)?.toOnlyDate()
                                    // );
                                  }}
                                /> */}
                                <NewThaiDatePicker name ={"search_data_from_date"} value={searchData?.fromDate} setValue={setFromDateSearch} returnType = {"DateTime"} placeholderText = "วัน/เดือน/ปี"/>
                              </Col>
                            </Row>
                          </Col>
                          <Col xxl={2} xl={3} sm={6} className="">
                            <Row>
                              <Label
                                className="text-end pe-0 mx-0"
                                xxl={3}
                                xl={3}
                                sm={3}
                                xs={2}
                              >
                                ถึง
                              </Label>
                              <Col>
                                {/* <Flatpickr
                                  className="form-control d-block"
                                  placeholder="วัน/เดือน/ปี"
                                  options={{
                                    dateFormat: "d-m-Y",
                                    ariaDateFormat: "F j, Y",
                                    locale: "th",
                                  }}
                                  value={searchData?.toDate}
                                  onChange={(e) => {
                                    setSearchData((prev) => ({
                                      ...prev,
                                      toDate: e[0],
                                    }));
                                    if (searchData?.fromDate !== "") return 0;
                                    // return getLeaveDataTable(
                                    // 1,
                                    // selectRow,
                                    // "created_date",
                                    // "DESC",
                                    // searchData?.title,
                                    // ConvertDate(searchData?.fromDate)?.toOnlyDate(),
                                    // ConvertDate(e[0])?.toOnlyDate()
                                    // );
                                  }}
                                /> */}
                                <NewThaiDatePicker name ={"search_data_to_date"} value={searchData?.toDate} minDate = {searchData?.fromDate} setValue={setToDateSearch} returnType = {"DateTime"} placeholderText = "วัน/เดือน/ปี"/>
                              </Col>
                            </Row>
                          </Col>
                          <Col xl={2} sm={6}>
                            <Row>
                              <Label
                                className="text-end pe-0"
                                xl={4}
                                sm={3}
                                xs={2}
                              >
                                สถานะ
                              </Label>
                              <Col>
                            <Input
                              type="select"
                              onChange={(e) => {
                                setSearchData((prev) => ({
                                  ...prev,
                                  status: e.target.value,
                                }));
                              }}
                            >
                              {options.map(option => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </Input>
                          </Col>
                            </Row>
                            
                          </Col>
                          <Col xl={3} sm={6} className="mt-xl-2 mt-xxl-0">
                            <Row>
                              <Label className="text-end " xl={5} sm={5} xs={4}>
                                ปีงบประมาณ
                              </Label>
                              <Col>
                                <Input
                                  value={searchData?.budget_year}
                                  type="select"
                                  onChange={(e) => {
                                    setSearchData((prev) => ({
                                      ...prev,
                                      budget_year: Number(e.target.value),
                                    }));
                                  }}
                                >
                                  {budgetYearSelectList?.length > 0 &&
                                    budgetYearSelectList?.map((item, idx) => {
                                      return (
                                        <option key={idx} value={item}>
                                          {item}
                                        </option>
                                      );
                                    })}
                                </Input>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                      <Col xl={2} className="text-end">
                        {/* <Button
                          className="fs-6 fw-bold text-dark"
                          color="warning"
                          onClick={() => {
                            // getLeaveDataTable(currentPage);
                            setSearchData((prev) => ({
                              ...prev,
                              title: "",
                              fromDate: "",
                              toDate: "",
                            }));
                            setSortCount((prev) => ({
                              ...prev,
                              id: 0,
                              typeId: 0,
                              fromDate: 0,
                              toDate: 0,
                            }));
                          }}
                        >
                          ล้างการค้นหา
                        </Button> */}
                      </Col>
                    </Row>
                  </Form>
                </Col>
              </Row>
              <Row className="my-2 d-flex align-items-center justify-content-end">
              {(CheckSubAdmin(userInfo?.positionSubAdmin).length > 0 && (CheckSubAdmin(userInfo?.positionSubAdmin).includes(0) || CheckSubAdmin(userInfo?.positionSubAdmin).includes(1))) ? <Col xxl={3} xl={3} xs={12}>
                <Row>
                  <Label
                    className="text-end pe-0"
                    xl={4}
                    sm={4}
                    xs={4}
                  >
                    ดูการลาของเจ้าหน้าที่
                  </Label>
                  <Col>
                    <InputGroup className="w-100">
                      <Input
                        readOnly
                        placeholder="...เลือกเจ้าหน้าที่"
                        type="text"
                        value={searchData?.user_name || ""}
                      />
                      <ModalUser task="select_user_filter" defaultValue={"ไม่เลือกเจ้าหน้าที่"}/>
                    </InputGroup>
                  </Col>
                </Row>
              </Col>: null}
                <Col className="d-flex align-items-center justify-content-end" xxl = {3}>
                  <Button
                    color="success"
                    className="mx-2 w-50"
                    onClick={() => {
                      getSearchLeaveData();
                      // setSearchData((prev) => ({
                      //   ...prev,
                      //   title: "",
                      //   fromDate: "",
                      //   toDate: "",
                      // }));
                      // setSortCount((prev) => ({
                      //   ...prev,
                      //   id: 0,
                      //   typeId: 0,
                      //   fromDate: 0,
                      //   toDate: 0,
                      // }));
                    }}
                  >
                    <i className="fa-sharp fa-solid fa-magnifying-glass pe-1"></i>ค้นหา
                  </Button>
                  <Button
                    color="warning"
                    className="w-50"
                    onClick={() => {
                      // getLeaveDataTable(currentPage);
                      setSearchData((prev) => ({
                        ...prev,
                        leave_type_id: "",
                        fromDate: "",
                        toDate: "",
                        status: "",
                        budget_year: "",
                      }));
                      setSortCount((prev) => ({
                        ...prev,
                        id: 0,
                        typeId: 0,
                        fromDate: 0,
                        toDate: 0,
                      }));
                    }}
                  >
                    <i className="fas fa-xmark me-2"></i>ล้างการค้นหา
                  </Button>
                </Col>
              </Row>
            </>
          )}
          <Row>
            <Col>
              {isloading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "300px",
                  }}
                >
                  <LoadingData />
                </div>
              ) : (
                <>
                  <FadeIn>
                    {leaveData?.length === 0 ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          minHeight: "400px",
                        }}
                      >
                        <h3>ไม่มีรายการลา</h3>
                      </div>
                    ) : (
                      <>
                        <div
                          style={{ overflowX: "scroll", minHeight: "250px" }}
                        >
                          <Table
                            className=""
                            striped
                            hover
                            style={{
                              verticalAlign: "middle",
                              whiteSpace: "nowrap",
                              width: "100%",
                            }}
                          >
                            <thead className="table-primary fs-5 fw-bold">
                              <tr>
                                <th className="text-center" width="5%">
                                  ลำดับ
                                </th>
                                <th
                                  width="5%"
                                  className="text-center"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    handleSortDataTable(
                                      sortCount?.id,
                                      "id",
                                      "leave_data_id"
                                    );
                                  }}
                                >
                                  เลขที่ใบลา
                                  {/* {sortCount?.id === 0 ? (
                                    <>&nbsp;&nbsp;&nbsp;</>
                                  ) : sortCount?.id === 1 ? (
                                    <i class="fa-solid fa-down"></i>
                                  ) : (
                                    <i class="fa-solid fa-up"></i>
                                  )} */}
                                </th>
                                <th
                                  width="35%"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    handleSortDataTable(
                                      sortCount?.typeId,
                                      "typeId",
                                      "leave_type_id"
                                    );
                                  }}
                                >
                                  หัวข้อการลา
                                  {sortCount?.typeId ===
                                  0 ? null : sortCount?.typeId === 1 ? (
                                    <i class="fa-solid fa-down ms-1"></i>
                                  ) : (
                                    <i class="fa-solid fa-up ms-1"></i>
                                  )}
                                </th>
                                <th
                                  width="15%"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    handleSortDataTable(
                                      sortCount?.fromDate,
                                      "fromDate",
                                      "leave_from_date"
                                    );
                                  }}
                                  className="text-center"
                                >
                                  ตั้งแต่วันที่{" "}
                                  {sortCount?.fromDate ===
                                  0 ? null : sortCount?.fromDate === 1 ? (
                                    <i class="fa-solid fa-down ms-1"></i>
                                  ) : (
                                    <i class="fa-solid fa-up ms-1"></i>
                                  )}
                                </th>
                                <th
                                  width="15%"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    handleSortDataTable(
                                      sortCount?.toDate,
                                      "toDate",
                                      "leave_to_date"
                                    );
                                  }}
                                  className="text-center"
                                >
                                  ถึงวันที่{" "}
                                  {sortCount?.toDate ===
                                  0 ? null : sortCount?.toDate === 1 ? (
                                    <i class="fa-solid fa-down ms-1"></i>
                                  ) : (
                                    <i class="fa-solid fa-up ms-1"></i>
                                  )}
                                </th>
                                <th width="5%" className="text-center">
                                  รวม
                                </th>
                                <th width="10%" className="text-center">
                                  สถานะใบลา
                                </th>
                                {/* <th className="text-center">สถานะการอนุมัติ</th> */}
                                {((searchData?.user_id ? (searchData?.user_id === user_id) : true) || isFromIndex) && <th className="text-center"></th>}
                              </tr>
                            </thead>
                            <tbody className="table-light">
                              {leaveData?.map((item, idx) => {
                                const leaveFromDate =
                                  item?.leave_from_date?.split("T");
                                const formDate = `${
                                  leaveFromDate[0].split("-")[2]
                                }-${leaveFromDate[0].split("-")[1]}-${
                                  leaveFromDate[0].split("-")[0]
                                }`;
                                const leaveToDate =
                                  item?.leave_to_date?.split("T");
                                const ToDate = `${
                                  leaveToDate[0].split("-")[2]
                                }-${leaveToDate[0].split("-")[1]}-${
                                  leaveToDate[0].split("-")[0]
                                }`;

                                let leaveFromTimeType = "";
                                if (item?.leave_from_timetype === "1")
                                  leaveFromTimeType = "09:30 น.";
                                if (item?.leave_from_timetype === "2")
                                  leaveFromTimeType = "13:00 น.";

                                let leaveToTimeType = "";
                                if (item?.leave_to_timetype === "2")
                                  leaveToTimeType = "17:30 น.";
                                if (item?.leave_to_timetype === "1")
                                  leaveToTimeType = "12:00 น.";

                                let selectRow = 0;
                                if (isFromIndex) selectRow = 5;
                                else selectRow = 10;

                                let hasCancelEdit = false;
                                if(item?.leave_type_id === 4)
                                hasCancelEdit = getDataCancelDayToEdit(item?.leave_data_id)

                                return (
                                  <tr
                                    key={item?.leave_data_id}
                                    style={{ cursor: "pointer" }}
                                  >
                                    <td
                                      onClick={() => {
                                        setModalState("view");
                                        setModalLeaveData(true);
                                        GetLeaveDataEdit(item?.leave_data_id);
                                        getFlowApproveUserbyId(
                                          item?.leave_data_id
                                        );
                                      }}
                                      className="text-center"
                                    >
                                      {idx +
                                        (leavePagination?.currentPage - 1) *
                                          selectRow +
                                        1}
                                    </td>
                                    <td
                                      className="text-center"
                                      onClick={() => {
                                        setModalState("view");
                                        setModalLeaveData(true);
                                        GetLeaveDataEdit(item?.leave_data_id);
                                        getFlowApproveUserbyId(
                                          item?.leave_data_id
                                        );
                                      }}
                                    >
                                      {item?.leave_data_id}
                                    </td>
                                    <td
                                      style={{
                                        maxWidth: "150px",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                      }}
                                      onClick={() => {
                                        setModalState("view");
                                        setModalLeaveData(true);
                                        GetLeaveDataEdit(item?.leave_data_id);
                                        getFlowApproveUserbyId(
                                          item?.leave_data_id
                                        );
                                      }}
                                    >
                                      {item?.leave_name}
                                    </td>
                                    <td
                                      onClick={() => {
                                        setModalState("view");
                                        setModalLeaveData(true);
                                        GetLeaveDataEdit(item?.leave_data_id);
                                        getFlowApproveUserbyId(
                                          item?.leave_data_id
                                        );
                                      }}
                                      className="text-center"
                                    >
                                      {/* {ConvertDate(
                                        item?.leave_from_date
                                      ).toThaiDateDMY()}{" "} */}
                                      {dayjs.utc(item?.leave_from_date).add(543,"year").format("DD MMM YYYY")}{" "}
                                      {isFromIndex === false &&
                                        `${leaveFromTimeType}`}
                                    </td>
                                    {/* <td className='text-center'>{item.leave_from_date.split("T")}</td> */}
                                    <td
                                      onClick={() => {
                                        setModalState("view");
                                        setModalLeaveData(true);
                                        GetLeaveDataEdit(item?.leave_data_id);
                                        getFlowApproveUserbyId(
                                          item?.leave_data_id
                                        );
                                      }}
                                      className="text-center"
                                    >
                                      {/* {ConvertDate(
                                        item?.leave_to_date
                                      ).toThaiDateDMY()}{" "} */}
                                      {dayjs.utc(item?.leave_to_date).add(543,"year").format("DD MMM YYYY")}{" "}
                                      {isFromIndex === false &&
                                        `${leaveToTimeType}`}
                                    </td>
                                    <td
                                      onClick={async () => {
                                        setModalState("view");
                                        setModalLeaveData(true);
                                        GetLeaveDataEdit(item?.leave_data_id);
                                        getFlowApproveUserbyId(
                                          item?.leave_data_id
                                        );
                                      }}
                                      className="text-center"
                                    >
                                      {item?.leave_days}
                                    </td>
                                    <td
                                      onClick={() => {
                                        setModalState("view");
                                        setModalLeaveData(true);
                                        GetLeaveDataEdit(item?.leave_data_id);
                                        getFlowApproveUserbyId(
                                          item?.leave_data_id
                                        );
                                      }}
                                      className="text-center"
                                    >
                                      <h5 className="my-auto">
                                        {leaveStatusBadge(item,hasCancelEdit)}
                                      </h5>
                                    </td>
                                    {((searchData?.user_id ? (searchData?.user_id === user_id) : true) || isFromIndex) && <td className="text-center">
                                      <Tooltip title="ตรวจสอบ">
                                        <button
                                          className="btn btn-info"
                                          onClick={() => {
                                            setModalState("view");
                                            setModalLeaveData(true);
                                            GetLeaveDataEdit(
                                              item?.leave_data_id
                                            );
                                            getFlowApproveUserbyId(
                                              item?.leave_data_id
                                            );
                                          }}
                                        >
                                          <i className="fa-solid fa-eye"></i>
                                        </button>
                                      </Tooltip>
                                      {item?.form_type !== 8 ? <Tooltip title="พิมพ์">
                                        <button
                                          className="ms-1 btn btn-success"
                                          onClick={async () => {
                                            // await handleGetReport(
                                            //   item?.leave_type_id,
                                            //   item?.leave_data_id
                                            // );
                                            // if (reportURL) {
                                            //   window.open(reportURL);
                                            //   reportURL = "";
                                            // }
                                            setLeaveTypeIdSelectFile(item?.leave_type_id)
                                            setLeaveDataIdSelectFile(item?.leave_data_id)
                                            setformNameFile(item?.form_name)
                                            toggleDownloadFileModal()
                                          }}
                                        >
                                          <i className="fa-solid fa-print"></i>
                                        </button>
                                      </Tooltip> : ""}
                                      {(item?.leave_status === "4" ||
                                        item?.leave_status === "9") && (
                                        <Tooltip title="แก้ไข">
                                          <button
                                            className="ms-1 btn btn-warning"
                                            onClick={() => {
                                              setModalState("edit");
                                              setModalLeaveData(true);
                                              GetLeaveDataEdit(
                                                item.leave_data_id
                                              );
                                              getFlowApproveUserbyId(
                                                item?.leave_data_id
                                              );
                                            }}
                                            color="warning"
                                          >
                                            <i className="fa-solid fa-pen-to-square"></i>
                                          </button>
                                        </Tooltip>
                                      )}

                                      {(item?.leave_status === "2" ||
                                        item?.leave_status === "3" ||
                                        item?.leave_status === "4" ||
                                        item?.leave_status === "9") && (
                                        <Tooltip title="ยกเลิก">
                                          <button
                                            className="ms-1 btn btn-danger"
                                            onClick={async () => {
                                              toggleCancelLeave("8");
                                              await GetLeaveDataEdit(
                                                item?.leave_data_id
                                              );
                                              setLeaveDataEdit((prev) => ({
                                                ...prev,
                                                cancel_status: "1",
                                              }));
                                            }}
                                          >
                                            <i className="fa-solid fa-trash"></i>
                                          </button>
                                        </Tooltip>
                                      )}
                                      {(item?.leave_status === "0" ||
                                        item?.leave_status === "5" ||
                                        item?.leave_status === "C") && (
                                        <Tooltip title="ขออนุญาตยกเลิก">
                                          <button
                                            className="ms-1 btn btn-danger"
                                            onClick={async () => {
                                              toggleCancelLeave("7");
                                              await GetLeaveDataEdit(
                                                item?.leave_data_id
                                              );
                                              setLeaveDataEdit((prev) => ({
                                                ...prev,
                                                cancel_status: "1",
                                              }));
                                            }}
                                          >
                                            <i className="fa-solid fa-trash-undo"></i>
                                          </button>
                                        </Tooltip>
                                      )}
                                    </td>}
                                  </tr>
                                );
                              })}
                            </tbody>
                          </Table>
                        </div>
                      </>
                    )}
                  </FadeIn>
                </>
              )}
            </Col>
          </Row>
        </CardBody>
        <Modal centered isOpen={modalCancel?.modal} toggle={toggleDownloadFileModal}>
        <ModalHeader toggle={toggleDownloadFileModal}>
          ดาวน์โหลดเอกสาร
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col className="d-flex align-items-center justify-content-end">
              <Button className="mx-2 btn-danger"
                disabled={loadingPdf}
                onClick={ async () => {
                  await handleGetReport(
                      leaveTypeIdSelectFile,
                      leaveDataIdSelectFile
                    );
                    if (reportURL) {
                      window.open(reportURL);
                      reportURL = "";
                    }
                  }
                }
                >{loadingPdf ? <i className="bx bx-loader bx-spin font-size-16 align-middle"/> : <i class="fa-solid fa-file-pdf p-1 fs-5"></i>}PDF</Button>
              <Button className="mx-2 btn-info"
                disabled={loadingDoc}
                onClick={()=>{
                  downloadDocx(
                      leaveTypeIdSelectFile,
                      leaveDataIdSelectFile,
                      formNameFile
                  )
                }}
              >{loadingDoc ? <i className="bx bx-loader bx-spin font-size-16 align-middle"/> : <i class="fa-solid fa-file-doc p-1 fs-5"></i>}DOCX</Button>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
        {leaveData?.length === 0 ? null : (
          <Row
            className="mx-2"
            style={{
              display: "flex",
              alignItems: "end",
            }}
          >
            <Col xxl={4} className="mb-2">
              <h4>
                <Badge className="badge-soft-primary me-1">
                  ทั้งหมด {leavePagination?.totalRows} รายการ
                </Badge>
              </h4>
            </Col>
            <Col xxl={8} className="d-flex justify-content-end">
              <Pagination aria-label="Page navigation example">
                <PaginationItem disabled={leavePagination?.currentPage === 1}>
                  <PaginationLink onClick={() => getSearchLeaveData(1)}>
                    {/* <i className="fas fa-angle-double-left"></i> */}
                    หน้าแรก
                  </PaginationLink>
                </PaginationItem>
                <PaginationItem disabled={leavePagination?.currentPage === 1}>
                  <PaginationLink
                    onClick={() =>
                      // getLeaveData(
                      //   leavePagination?.currentPage - 1, isFromIndex, searchData?.budget_year
                      // )
                      getSearchLeaveData(
                        // searchData?.currentPage -1
                        leavePagination?.currentPage - 1
                        )
                    }
                  >
                    ย้อนกลับ
                  </PaginationLink>
                </PaginationItem>
                <PaginationItem active>
                  <PaginationLink>
                    หน้า {leavePagination?.currentPage} จาก{" "}
                    {leavePagination?.totalPage}
                  </PaginationLink>
                </PaginationItem>
                <PaginationItem
                  disabled={
                    leavePagination?.currentPage === leavePagination?.totalPage
                  }
                >
                  <PaginationLink
                    onClick={() =>
                      // getLeaveData(
                      //   leavePagination?.currentPage + 1, isFromIndex, searchData?.budget_year
                      // )
                      getSearchLeaveData(
                        // searchData?.currentPage + 1
                        leavePagination?.currentPage + 1
                        )
                    }
                  >
                    ถัดไป
                  </PaginationLink>
                </PaginationItem>
                <PaginationItem
                  disabled={
                    leavePagination?.currentPage === leavePagination?.totalPage
                  }
                >
                  <PaginationLink
                    onClick={() =>
                      // getLeaveData(leavePagination?.totalPage, isFromIndex, searchData?.budget_year)
                      getSearchLeaveData(
                        // searchData?.totalPage
                        leavePagination?.totalPage
                        )
                    }
                  >
                    {/* <i className="fas fa-angle-double-right "></i> */}
                    หน้าสุดท้าย
                  </PaginationLink>
                </PaginationItem>
              </Pagination>
            </Col>
          </Row>
        )}
      </Card>

      <ModalCancelLeave
        leaveDataEdit={leaveDataEdit}
        setLeaveDataEdit={setLeaveDataEdit}
        cancelLeave={cancelLeave}
        toggleCancelLeave={toggleCancelLeave}
        handleCancelLeave={handleCancelLeave}
        allDayCancel={allDayCancel}
        setAllDayCancel={setAllDayCancel}
        getAllDayCancel={getAllDayCancel}
        selectDayCancel={selectDayCancel}
        setSelectDayCancel={setSelectDayCancel}
        startCancel={startCancel}
        endCancel={endCancel}
      />
      <ModalViewOrEditTableForm
        userInfo={userInfo}
        getUserApprove={getUserApprove}
        getFlowApprove={getFlowApprove}
        configForm={configForm}
        modalState={modalState}
        modalLeaveData={modalLeaveData}
        ToggleModalLeaveData={ToggleModalLeaveData}
        handleEditLeaveDataEdit={handleEditLeaveDataEdit}
        handleEditDataInApproveTable={handleEditDataInApproveTable}
        leaveDataEdit={leaveDataEdit}
        setLeaveDataEdit={setLeaveDataEdit}
        handleOpenSubmitSuccess={handleOpenSubmitSuccess}
        allDayCancel={allDayCancel}
        setAllDayCancel={setAllDayCancel}
        getAllDayCancel={getAllDayCancel}
        selectDayCancel={selectDayCancel}
        setSelectDayCancel={setSelectDayCancel}
        getDataCancelDayById={getDataCancelDayById}
      />
      <ModalConfirmApprove
        submitSuccess={submitSuccess}
        handleOpenSubmitSuccess={handleOpenSubmitSuccess}
        handleCloseSubmitSuccess={handleCloseSubmitSuccess}
      />
    </React.Fragment>
  );
};

export default TableForm;
